import React from 'react'
import Skeleton from "react-loading-skeleton";
import moment from 'moment';

const AgentDetails = ({ agent }) => {
  return (
    <div>
      <div className='d-flex flex-wrap ml-2' style={{ gap: 10 }}>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Id
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{
              backgroundColor: "#FFF",
              borderRadius: 5,
              height: 50,
              width: 120,
            }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {agent?.id ? agent?.id : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p style={{ color: "#081528", fontSize: 20 }} className='mr-2 ml-4'>
            Names
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{
              backgroundColor: "#FFF",
              borderRadius: 5,
              height: 50,
            }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {!agent?.subscriber?.firstName === " " ||
              !agent?.subscriber?.lastName == "null null" ? (
                "Unknown"
              ) : agent?.subscriber ? (
                `${agent?.subscriber?.firstName} ${agent?.subscriber?.lastName}`
              ) : (
                <Skeleton />
              )}
            </p>
          </div>
        </div>
        <div>
          <p style={{ color: "#081528", fontSize: 20 }} className='mr-2 ml-4'>
            Phone Nbr
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{
              backgroundColor: "#FFF",
              borderRadius: 5,
              height: 50,
              width: 180,
            }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {agent?.subscriber ? (
                agent?.subscriber?.phoneNumber
              ) : (
                <Skeleton />
              )}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Subscriber Id
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {agent?.subscriber ? agent?.subscriber?.id : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-4 font-family'
          >
            Type
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {agent?.type ? agent?.type?.name : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Commission Rate
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-3'>
              {agent?.commissionRate ? agent?.commissionRate : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Status
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ borderRadius: 5, height: 50 }}
          >
            <p style={{ fontSize: 20, color: "#878793" }} className='ml-1'>
              {agent?.status ? agent?.status?.name : <Skeleton />}
            </p>
          </div>
        </div>
        <div>
          <p
            style={{ color: "#081528", fontSize: 20 }}
            className='mr-2 ml-3 font-family'
          >
            Created On
          </p>
          <div
            className='pt-2 mr-1 pr-2 mb-2 form-control input-select'
            style={{ backgroundColor: "#FFF", borderRadius: 5, height: 50 }}
          >
            <p
              style={{
                fontSize: 20,
                color: "#878793",
              }}
              className='ml-3'
            >
              {agent?.createdAt ? moment(agent?.createdAt).format("DD-MM-YYYY"): <Skeleton />}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentDetails